import { createSlice } from '@reduxjs/toolkit';
import { ProductDetailStateType } from 'src/types/productDetail';
import getErrorKeys from 'src/utils/getErrorKeys';

const initialState: ProductDetailStateType = {
    data: null,
    changelog: null,
    dataStock: null,
    dataOrders: null,
    dataStockMovements: null,
    dataProductReceivings: null,
    dataProductOrdersGrid: null,
    dataProductReturns: null,
    loading: false,
    error: false,
    apiErrorKeys: null,
};
export const productDetailSlice = createSlice({
    name: 'productDetail',
    initialState,
    reducers: {
        getProductDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        getProductDetailFetchFailure: (state, action) => {
            state.data = null;
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailChangelogFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailChangelogFetchSuccess: (state, action) => {
            state.changelog = action.payload.data;
            state.loading = false;
        },
        getProductDetailChangelogFetchFailure: (state, action) => {
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailStockFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailStockFetchSuccess: (state, action) => {
            state.dataStock = action.payload.data;
            state.loading = false;
        },
        getProductDetailStockFetchFailure: (state, action) => {
            state.dataStock = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailOrdersFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailOrdersFetchSuccess: (state, action) => {
            state.dataOrders = action.payload.data;
            state.loading = false;
        },
        getProductDetailOrdersFetchFailure: (state, action) => {
            state.dataOrders = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailStockMovementsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailStockMovementsFetchSuccess: (state, action) => {
            state.dataStockMovements = action.payload.data;
            state.loading = false;
        },
        getProductDetailStockMovementsFetchFailure: (state, action) => {
            state.dataStockMovements = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailProductReceivingsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailProductReceivingsFetchSuccess: (state, action) => {
            state.dataProductReceivings = action.payload.data;
            state.loading = false;
        },
        getProductDetailProductReceivingsFetchFailure: (state, action) => {
            state.dataProductReceivings = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailProductOrdersGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailProductOrdersGridFetchSuccess: (state, action) => {
            state.dataProductOrdersGrid = action.payload.data;
            state.loading = false;
        },
        getProductDetailProductOrdersGridFetchFailure: (state, action) => {
            state.dataProductOrdersGrid = null;
            state.loading = false;
            state.error = true;
        },
        getProductDetailProductReturnsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductDetailProductReturnsFetchSuccess: (state, action) => {
            state.dataProductReturns = action.payload.data;
            state.loading = false;
        },
        getProductDetailProductReturnsFetchFailure: (state, action) => {
            state.dataProductReturns = null;
            state.loading = false;
            state.error = true;
        },
        createProductDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            state.apiErrorKeys = null;
        },
        createProductDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        createProductDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.changelog = null;
            state.error = true;
            state.apiErrorKeys = getErrorKeys(action.payload);
        },
        updateProductDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            state.apiErrorKeys = null;
        },
        updateProductDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        updateProductDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.changelog = null;
            state.error = true;
            state.apiErrorKeys = getErrorKeys(action.payload);
        },
        deleteProductFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteProductFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        deleteProductFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.changelog = null;
            state.error = true;
        },
        activateProductFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        activateProductFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        activateProductFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.changelog = null;
            state.error = true;
        },
        deactivateProductFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deactivateProductFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        deactivateProductFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.changelog = null;
            state.error = true;
        },
        clearProductDetail: () => initialState,
    },
});

export const {
    getProductDetailFetch,
    getProductDetailFetchSuccess,
    getProductDetailFetchFailure,
    getProductDetailChangelogFetch,
    getProductDetailChangelogFetchSuccess,
    getProductDetailChangelogFetchFailure,
    getProductDetailStockFetch,
    getProductDetailStockFetchSuccess,
    getProductDetailStockFetchFailure,
    getProductDetailOrdersFetch,
    getProductDetailOrdersFetchSuccess,
    getProductDetailOrdersFetchFailure,
    getProductDetailStockMovementsFetch,
    getProductDetailStockMovementsFetchSuccess,
    getProductDetailStockMovementsFetchFailure,
    getProductDetailProductReceivingsFetch,
    getProductDetailProductReceivingsFetchSuccess,
    getProductDetailProductReceivingsFetchFailure,
    getProductDetailProductOrdersGridFetch,
    getProductDetailProductOrdersGridFetchSuccess,
    getProductDetailProductOrdersGridFetchFailure,
    getProductDetailProductReturnsFetch,
    getProductDetailProductReturnsFetchSuccess,
    getProductDetailProductReturnsFetchFailure,
    createProductDetailFetch,
    createProductDetailFetchSuccess,
    createProductDetailFetchFailure,
    updateProductDetailFetch,
    updateProductDetailFetchSuccess,
    updateProductDetailFetchFailure,
    deleteProductFetch,
    deleteProductFetchSuccess,
    deleteProductFetchFailure,
    activateProductFetch,
    activateProductFetchSuccess,
    activateProductFetchFailure,
    deactivateProductFetch,
    deactivateProductFetchSuccess,
    deactivateProductFetchFailure,
    clearProductDetail,
} = productDetailSlice.actions;

export default productDetailSlice.reducer;
